/**
 * Utilitários para manipulação de datas
 */

/**
 * Nomes dos dias da semana em português
 */
export const DIAS_SEMANA = [
  'Domingo', 
  'Segunda-feira', 
  'Terça-feira', 
  'Quarta-feira', 
  'Quinta-feira', 
  'Sexta-feira', 
  'Sábado'
];

/**
 * Nomes dos meses em português
 */
export const MESES = [
  'Janeiro', 'Fevereiro', 'Março', 'Abril', 
  'Maio', 'Junho', 'Julho', 'Agosto', 
  'Setembro', 'Outubro', 'Novembro', 'Dezembro'
];

/**
 * Retorna a data atual no formato YYYY-MM-DD
 */
export const obterDataAtual = (): string => {
  const hoje = new Date();
  const ano = hoje.getFullYear();
  const mes = String(hoje.getMonth() + 1).padStart(2, '0');
  const dia = String(hoje.getDate()).padStart(2, '0');
  return `${ano}-${mes}-${dia}`;
};

/**
 * Cria uma data segura (meio-dia) para evitar problemas com timezone
 */
export const criarDataSegura = (dataStr: string): Date => {
  const [ano, mes, dia] = dataStr.split('-').map(Number);
  return new Date(ano, mes - 1, dia, 12, 0, 0);
};

/**
 * CORREÇÃO COMPLETA: Calcula datas recorrentes baseado em uma data inicial
 */
export const calcularDatasRecorrentesCompleta = (
  dataInicial: string,
  diaSemana: number,
  quantidadeConsultas: number
): string[] => {
  const datas: string[] = [];
  
  if (!dataInicial || quantidadeConsultas <= 0) {
    return datas;
  }
  
  // Parse da data inicial garantindo timezone local
  const [ano, mes, dia] = dataInicial.split('-').map(Number);
  const dataBase = new Date(ano, mes - 1, dia, 12, 0, 0);
  
  console.log(`[calcularDatasRecorrentesCompleta] Data base: ${dataBase.toLocaleDateString('pt-BR')} (${DIAS_SEMANA[dataBase.getDay()]})`);
  console.log(`[calcularDatasRecorrentesCompleta] Dia da semana desejado: ${DIAS_SEMANA[diaSemana]}`);
  
  // Encontrar a primeira ocorrência do dia da semana desejado
  let proximaOcorrencia = new Date(dataBase);
  
  const diaAtual = proximaOcorrencia.getDay();
  let diasParaAvancar = diaSemana - diaAtual;
  
  // Se o dia já passou, ir para próxima semana
  if (diasParaAvancar < 0) {
    diasParaAvancar += 7;
  }
  
  // Avançar para o dia correto (se necessário)
  if (diasParaAvancar > 0) {
    proximaOcorrencia.setDate(proximaOcorrencia.getDate() + diasParaAvancar);
  }
  
  console.log(`[calcularDatasRecorrentesCompleta] Primeira ocorrência: ${proximaOcorrencia.toLocaleDateString('pt-BR')} (${DIAS_SEMANA[proximaOcorrencia.getDay()]})`);
  
  // Verificação de segurança
  if (proximaOcorrencia.getDay() !== diaSemana) {
    console.error(`[ERRO CRÍTICO] Falha no cálculo: esperado ${DIAS_SEMANA[diaSemana]}, obtido ${DIAS_SEMANA[proximaOcorrencia.getDay()]}`);
    return [];
  }
  
  // Gerar datas semanais
  for (let i = 0; i < quantidadeConsultas; i++) {
    const dataConsulta = new Date(proximaOcorrencia);
    dataConsulta.setDate(proximaOcorrencia.getDate() + (i * 7));
    
    // Validar que o dia da semana permanece correto
    if (dataConsulta.getDay() !== diaSemana) {
      console.error(`[ERRO] Inconsistência na semana ${i + 1}: esperado ${DIAS_SEMANA[diaSemana]}, obtido ${DIAS_SEMANA[dataConsulta.getDay()]}`);
      continue;
    }
    
    const anoConsulta = dataConsulta.getFullYear();
    const mesConsulta = String(dataConsulta.getMonth() + 1).padStart(2, '0');
    const diaConsulta = String(dataConsulta.getDate()).padStart(2, '0');
    
    datas.push(`${anoConsulta}-${mesConsulta}-${diaConsulta}`);
  }
  
  return datas;
};

/**
 * Adiciona uma duração especificada (em minutos) a uma hora
 */
export const adicionarDuracaoHora = (hora: string, duracao: number = 60): string => {
  const [horas, minutos] = hora.split(':').map(Number);
  
  let novasHoras = horas;
  let novosMinutos = minutos + duracao;
  
  while (novosMinutos >= 60) {
    novosMinutos -= 60;
    novasHoras += 1;
  }
  
  novasHoras = novasHoras % 24;
  
  return `${String(novasHoras).padStart(2, '0')}:${String(novosMinutos).padStart(2, '0')}`;
};

/**
 * Converte qualquer objeto Date ou string de data para uma string no formato YYYY-MM-DD
 * Função segura que aceita múltiplos tipos e sempre retorna string no formato correto
 * @param date Objeto Date, string de data ou null/undefined
 * @returns String formatada como YYYY-MM-DD ou string vazia se inválida
 */
export function ensureStringDate(date: Date | string | null | undefined): string {
  if (!date) return '';
  
  // Se já for string, verificar se está no formato correto
  if (typeof date === 'string') {
    // Se já estiver no formato YYYY-MM-DD, retornar como está
    if (/^\d{4}-\d{2}-\d{2}$/.test(date)) {
      return date;
    }
    
    // Tentar converter string em outros formatos
    try {
      const dateObj = new Date(date);
      if (isNaN(dateObj.getTime())) return '';
      
      return dateObj.toISOString().split('T')[0];
    } catch (e) {
      console.error('Erro ao converter string de data:', e);
      return '';
    }
  }
  
  // Converter objeto Date para string
  try {
    return date.toISOString().split('T')[0];
  } catch (e) {
    console.error('Erro ao converter Date para string:', e);
    return '';
  }
}
